import React from "react";
import "./Tanakayu1.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Jivaimages from "../../../Media/BSD/Tanakayu/Jiva";
import Svastiimages from "../../../Media/BSD/Tanakayu/Svasti";
import Svaniimages from "../../../Media/BSD/Tanakayu/Svani";
import Svadhiimages from "../../../Media/BSD/Tanakayu/Svadhi";
import Chavaimages from "../../../Media/BSD/Tanakayu/Chava";
import Vasyaimages from "../../../Media/BSD/Tanakayu/Vasya";

const imageMap = {
  Jivaimages,
  Svastiimages,
  Svaniimages,
  Svadhiimages,
  Chavaimages,
  Vasyaimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Briza" className="produk">
      <h1>Our Home</h1>
      <h2>Cicilan Start 11 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
